module.exports = __webpack_public_path__ + "img/soundwave.e0b07443.jpg";